import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { withStyles } from '@material-ui/core/styles';
import { DEFAULT_THEME_COLOR } from 'appenv';
import ClickableText from 'components/ClickableText';

const StyledHelpOutlineIcon = withStyles(() => ({
  root: {
    height: 21,
    width: 21,
    marginRight: '5.5px',
  },
}))(HelpOutlineIcon);

const ContactSupportText = styled.span`
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: ${({ color }) => color};
`;

const ContactSupportContainer = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  line-height: 20px;
  padding: 0 15px;
  grid-gap: 5px;
  margin: 24px 0;
  white-space: break-spaces;
  color: #282B40;

  & path {
    fill: #282B40;
  }
`;

const ContactSupport = ({ handleClose }: {
  handleClose: () => void;
}) => {
  const { t } = useTranslation();

  const onCsLinkClick = useCallback(() => {
    handleClose();
    const { $zopim } = window;
    $zopim(() => {
      $zopim.livechat.window.show();
    });
  }, [handleClose]);
  const { themeColor } = useSelector((s) => (s as any).eventConfigs);
  const resolvedColor = themeColor || DEFAULT_THEME_COLOR;
  return (
    <ContactSupportContainer>
      <StyledHelpOutlineIcon color={resolvedColor} />
      {t('lobby.registration.need_help', 'Need help?')}
      <ClickableText
        onClick={onCsLinkClick}
        color={resolvedColor}
      >
        <ContactSupportText color={resolvedColor}>
          {t('contact_us', 'Contact us')}
        </ContactSupportText>
      </ClickableText>
    </ContactSupportContainer>
  );
};

export default ContactSupport;
